import { Injectable } from '@angular/core';
import { Inputfiledsbase } from '../../models/inputfiledsbase';
import { of } from 'rxjs';
import { TextareaQuestion } from '../../question-textarea';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { DatepickerQuestion } from '../../question-datepicker';
import { TimepickerQuestion } from '../../question-timepicker';
import { DropdownQuestion } from '../../question-dropdown';
import { DropdownservicesService } from '../../../Services/Apis/Dropdownservices/dropdownservices.service';

@Injectable({
  providedIn: 'root'
})
export class permissionService {

  organisationdata: any = [];

  constructor(private apiservice: ApiservicesService, private dropdownservice: DropdownservicesService) {
    // this.apiservice.getorganizationdrop().subscribe((res) => 
    //   {
    //     for(let i=0; i <= res.length; i++){
    //       this.organisationdata?.push({id:res[i].id, key: res[i].short_name, value:res[i].id})
    //     }
    //   }); 
  }
  getPermissionLeaves() {
    const questions: Inputfiledsbase<string>[] = [

      new TimepickerQuestion({
        key: 'start_time',
        label: 'Start Time',
        type: 'datetime',
        required: true,
        order: 1
      }),

      new TimepickerQuestion({
        key: 'end_time',
        label: 'End Time',
        type: 'datetime',
        required: true,
        order: 2
      }),

      new DatepickerQuestion({
        key: 'date',
        label: 'Date',
        required: true,
        position:'FULL',
        order: 3
      }),

      new TextareaQuestion({
        key: 'reason',
        label: 'Reason',
        required: true,
        position:'FULL',
        order: 4
      })
    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }
}
